<template>
  <div class="ibox float-e-margins">
    <div v-if="loaded && user.admin">
      <modal-form :add-order="order"></modal-form>
    </div>
    <order-header></order-header>
    <order-content></order-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Header from './Order/Header'
import Content from './Order/Content'
import Modal from './Order/OrderModal'
import axios from 'axios'
import { LINK_ORDER_SET } from '../../../../store/mutation-types'

export default {
  data () {
    return {
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      order: 'getLinkOrder',
      user: 'getUser'
    })
  },
  components: {
    orderHeader: Header,
    orderContent: Content,
    modalForm: Modal
  },
  mounted () {
    this.loaded = false
    this.loadOrder()
  },
  methods: {
    loadOrder () {
      this.loaded = false
      axios.get(`/pbn/links/order/${this.$route.params.id}?`)
        .then(r => {
          this.loaded = true
          this.$store.commit(LINK_ORDER_SET, r.data)
        })
        .catch(e => {
          throw e
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order.vue